import React from "react";
import Tabs from "../Tabs";

const InstantPaymentMethods = (props) => {
    const { acceptedPayments, handleTabClick, numberOfStandardPaymentMethods } =
        props;

    return numberOfStandardPaymentMethods > 1 ? (
        <div className="col col--12 -padding-top--0 -padding-left--0">
            <Tabs
                handleClick={handleTabClick}
                size="regular"
                tabData={acceptedPayments}
            />
        </div>
    ) : (
        <>
            <h4>{acceptedPayments[0]?.label}</h4>
            {acceptedPayments[0]?.content}
        </>
    );
};

export default InstantPaymentMethods;
